import React from 'react';
import {useLocation} from "react-router-dom";
import {useAuth} from '@trimble-oss/trimble-id-react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import trimbleLogo from '../../assets/trimble.svg';
import {PAGES} from '../PAGE_CONSTANTS';
import useNavigate from '../../routers/useNavigate';
import {AUTOMATION_REDIRECT_PARAMETER} from "@/constants";

const Header = () => {
    const {isAuthenticated, loginWithRedirect} = useAuth();
    const navigate = useNavigate();
    const {search} = useLocation();
    const handleLogin = async () => {
        const queryParams = new URLSearchParams(search)
        const e2e = queryParams.get('e2e');
        const redirectParameters = e2e ? `&${AUTOMATION_REDIRECT_PARAMETER}` : '';
        await loginWithRedirect({
            onRedirect: (redirect: string) => {
                window.location.assign(`${redirect}${redirectParameters}`);
            },
        });
    };
    const handleNavigateHome = async () => {
        navigate({
            pageName: PAGES.HOME,
        });
    };
    return (
        <div
            style={{
                height: '64px',
                backgroundColor: '#0063a3',
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            <div style={{textAlign: 'left', padding: '1.2rem 1rem'}}>
                <img src={trimbleLogo} alt='Trimble Logo' style={{height: '100%'}}/>
            </div>
            <div
                style={{
                    textAlign: 'right',
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0.5rem',
                }}
            >
                {isAuthenticated && (
                    <button
                        style={{color: 'white', border: 'none', cursor: 'pointer'}}
                        onClick={handleNavigateHome}
                    >
                        Home
                    </button>
                )}
                {!isAuthenticated && (
                    <button
                        style={{color: 'white', border: 'none', cursor: 'pointer'}}
                        onClick={handleLogin}
                    >
                        Login
                    </button>
                )}
            </div>
        </div>
    );
};

export default Header;
